const doc = [({"da":({"js":({"admin":({"plans":({"table":({"membership_period":"Medlemsperiode"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;